import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface RegistrationCTAButtonProps extends Omit<HTMLMotionProps<'button'>, 'children'> {
  children: React.ReactNode;
}
/**
 * Registration flow CTA button.
 * 278x56px, 8px radius, Poppins 16px Regular, gradient #D05220 → #F26428.
 * Disabled: solid #D1D1D1, cursor-not-allowed, full opacity.
 */
export function RegistrationCTAButton({
  children,
  disabled,
  style,
  ...rest
}: RegistrationCTAButtonProps) {
  return <motion.button whileTap={disabled ? undefined : {
    scale: 0.98
  }} disabled={disabled} {...rest} style={{
    width: 278,
    maxWidth: '100%',
    height: 56,
    borderRadius: 8,
    background: disabled ? '#D1D1D1' : '#661806',
    color: '#FFFFFF',
    fontFamily: 'Poppins, system-ui, sans-serif',
    fontWeight: 400,
    fontSize: 16,
    textAlign: 'center',
    cursor: disabled ? 'not-allowed' : 'pointer',
    border: 'none',
    opacity: 1,
    boxShadow: disabled ? 'none' : '0 6px 16px rgba(102,24,6,0.25)',
    transition: 'background 0.2s ease, box-shadow 0.2s ease',
    ...style
  }} data-id="element-2722">
      {children}
    </motion.button>;
}